import { UserTypeEnum } from '../enums/user-type.enum';
import {
  HeaderItem,
  adminBenefitsHeaderItems,
  clientBenefitsHeaderItems,
  visitorHeaderItems
} from './header-items';

type AppDefaultRoutes = {
  userType: string;
  defaultRoute: string;
  appContext: string;
  headerItems: HeaderItem[];
};

export const contextDefaultAppRoutes: AppDefaultRoutes[] = [
  {
    userType: UserTypeEnum.AjutoarePrimarie,
    defaultRoute: '/indemnizatii-primarie',
    appContext: '/indemnizatii-primarie',
    headerItems: clientBenefitsHeaderItems
  },
  {
    userType: UserTypeEnum.AjutoareAdmin,
    defaultRoute: '/admin-indemnizatii-primarie',
    appContext: '/admin-indemnizatii-primarie',
    headerItems: adminBenefitsHeaderItems
  },
  {
    userType: UserTypeEnum.Visitor,
    defaultRoute: '/',
    appContext: '/',
    headerItems: visitorHeaderItems
  }
];
